import dayjs from 'dayjs';

export const yyyyMNddOf = (day, invalid = '') => {
  const d = dayjs(day);
  if (!d.isValid()) {
    return invalid;
  }
  return d.format('YYYY/MM/DD');
};
